import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaBrainHistory = React.lazy(() =>
    import('../NebulaBrainHistory')
);
const nebulaBrainHistoryRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_BRAIN_HISTORY_PAGE,
        element: <NebulaBrainHistory />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaBrainHistoryRoutesRegistry;
